import { Box, Theme, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { LazyBox } from "@outschool/ui-components-shared";
import {
  HeadingMarker,
  PublicReviewsOfActivity
} from "@outschool/ui-components-website";
import { Container, Loading } from "@outschool/ui-legacy-component-library";
import React from "react";

import { ClassDetailsReviewsProps } from "./Components";

export function ReviewsSection({
  activity,
  reviewsRef,
  setTabValue,
  tabValue,
  ReviewRespondButton
}: ClassDetailsReviewsProps) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\ClassDetailsMainBody\\ClassDetailsReviews"
  );
  return (
    <Box
      flex
      sx={{
        flexDirection: "column",
        marginTop: 0
      }}
    >
      <Box
        flex
        sx={{
          flexDirection: "column"
        }}
        ref={reviewsRef}
      >
        <HeadingMarker />
        <Typography
          variant="h2"
          id="reviews"
          sx={(theme: Theme) => ({
            fontWeight: 700,
            marginBottom: "1.2rem",
            [theme.breakpoints.down("md")]: {
              marginBottom: 0
            }
          })}
        >
          {t("Reviews")}
        </Typography>
        <LazyBox
          placeholder={
            <Container size="small">
              <Loading />
            </Container>
          }
        >
          <PublicReviewsOfActivity
            activity={activity}
            ReviewRespondButton={ReviewRespondButton}
            tabValue={tabValue}
            setTabValue={setTabValue}
          />
        </LazyBox>
      </Box>
    </Box>
  );
}
